module.exports = __webpack_public_path__ + "img/05010016.7e7c619e.jpg";